export const siteOrigin = 'https://www.calculato.co';

export const isIndexable = page => Boolean(page) && page.indexable !== false;

/** Only describe features and relationships that are visible on the page. */
export function pageSchema(page) {
  if (!isIndexable(page)) return null;
  const url = siteOrigin + page.path;
  const calculator = page.path.endsWith('-calculator');
  const entity = {
    '@type': calculator ? 'WebApplication' : 'WebPage',
    '@id': url + '#page', name: page.heading, description: page.description,
    url, inLanguage: 'en',
    ...(calculator ? { applicationCategory: 'UtilitiesApplication', operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' } } : {})
  };
  const breadcrumb = {
    '@type': 'BreadcrumbList',
    itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Calculato', item: siteOrigin + '/' },
      ...(page.path === '/' ? [] : [{ '@type': 'ListItem', position: 2, name: page.heading, item: url }])]
  };
  const website = page.path === '/' ? [{
    '@type': 'WebSite', '@id': siteOrigin + '/#website',
    name: 'Calculato', alternateName: 'Calculato.co', url: siteOrigin + '/'
  }] : [];
  return { '@context': 'https://schema.org', '@graph': [...website, entity, breadcrumb] };
}

export function sitemapXml(pages) {
  return '<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n' +
    pages.filter(isIndexable).map(page => `  <url><loc>${siteOrigin}${page.path}</loc>${page.modified ? `<lastmod>${page.modified}</lastmod>` : ''}</url>`).join('\n') +
    '\n</urlset>\n';
}
